/**
 * @generated SignedSource<<c9ab82a3e909746ead86e100d3092711>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BestPaymentMethod_PaymentOptionConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly installments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly value: {
              readonly amount: number;
            };
          };
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"BestPaymentDrawer_PaymentOption" | "utils_PaymentOption">;
    };
  }>;
  readonly " $fragmentType": "BestPaymentMethod_PaymentOptionConnection";
};
export type BestPaymentMethod_PaymentOptionConnection$key = {
  readonly " $data"?: BestPaymentMethod_PaymentOptionConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"BestPaymentMethod_PaymentOptionConnection">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "value",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "total",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BestPaymentMethod_PaymentOptionConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentOptionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentOption",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentOptionInstallmentConnection",
              "kind": "LinkedField",
              "name": "installments",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaymentOptionInstallmentEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PaymentOptionInstallment",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BestPaymentDrawer_PaymentOption"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "utils_PaymentOption",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaymentOptionInstallmentConnection",
                  "kind": "LinkedField",
                  "name": "installments",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PaymentOptionInstallmentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PaymentOptionInstallment",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "interestRate",
                              "storageKey": null
                            },
                            (v2/*: any*/),
                            (v1/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentOptionConnection",
  "abstractKey": null
};
})();

(node as any).hash = "1f4601bb12366d859851c0e6c44d25a0";

export default node;
